import React from "react";
import { DELIVERED_SERVICE_STATUS_OPTIONS } from "Constants/constant";

/**
 * Renders a pill for COS/AH created-invoice list "participant based" status.
 * provider_paid → green, extract_generated → blue, others → neutral gray.
 */
export const invoiceListStatusBadge = (status) => {
  if (!status) {
    return <span className="text-gray-400">—</span>;
  }
  const label =
    DELIVERED_SERVICE_STATUS_OPTIONS.find((o) => o.value === status)?.label ||
    status.replace(/_/g, " ");
  if (status === "provider_paid") {
    return (
      <span className="inline-flex rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
        {label}
      </span>
    );
  }
  if (status === "extract_generated") {
    return (
      <span className="inline-flex rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
        {label}
      </span>
    );
  }
  return (
    <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700">
      {label}
    </span>
  );
};
